import type { KeyboardEvent as ReactKeyboardEvent } from "react";

type NativeKeyState = Pick<KeyboardEvent, "isComposing" | "keyCode">;

/**
 * True while a keystroke belongs to an IME composition, including the Enter
 * that confirms a CJK candidate. Some IMEs (Safari, older Chrome on macOS)
 * report that Enter only through `keyCode === 229` with `isComposing` false, so
 * an Enter-to-save/send handler that checks `isComposing` alone still commits
 * the half-composed text (BRE-8444).
 */
export function isImeComposing(event: NativeKeyState | ReactKeyboardEvent): boolean {
  const native: NativeKeyState = "nativeEvent" in event ? event.nativeEvent : event;
  return native.isComposing || native.keyCode === 229;
}
